import React, { useState } from 'react';
import { Package, Truck, DollarSign, MapPin, Phone, Mail, ArrowRight, Globe, Shield } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { useToast } from '../hooks/use-toast';
import { Helmet } from 'react-helmet-async';

const WaterlooToIndiaPage = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', weight: '' });
  const { toast } = useToast();
  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
  const handleSubmit = (e) => {
    e.preventDefault();
    toast({ title: "Quote Request Received!", description: "Our team will contact you within 24 hours." });
    setFormData({ name: '', email: '', phone: '', weight: '' });
  };

  return (
    <>
      <Helmet>
        <title>Waterloo to India Courier | Affordable Shipping – Shippzy</title>
        <meta name="description" content="Ship from Waterloo to India with Shippzy. Compare DHL, FedEx, UPS rates. Door-to-door delivery, customs support, local Waterloo pickup available." />
        <link rel="canonical" href="https://www.shippzy.ca/waterloo-to-india-courier" />
      </Helmet>
      <div className="min-h-screen bg-white">
        <section className="bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl">
              <h1 className="text-5xl md:text-6xl font-bold mb-6">Shipping from Waterloo to India</h1>
              <p className="text-xl text-gray-300 mb-8">Shippzy provides reliable courier services from Waterloo, Ontario to India. Door-to-door delivery with DHL, FedEx, and UPS at competitive rates.</p>
              <Button className="bg-gradient-to-r from-red-600 to-yellow-500 hover:from-red-700 hover:to-yellow-600 text-white px-8 py-6 text-lg" onClick={() => document.getElementById('quote-form').scrollIntoView({ behavior: 'smooth' })}>Get Quote</Button>
            </div>
          </div>
        </section>
        <section id="quote-form" className="py-20 bg-gradient-to-r from-red-600 to-yellow-500">
          <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
            <Card className="shadow-2xl">
              <CardHeader><CardTitle className="text-2xl text-center">Get Free Quote from Waterloo</CardTitle></CardHeader>
              <CardContent>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <Input name="name" value={formData.name} onChange={handleChange} required placeholder="Your name" />
                  <Input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="your@email.com" />
                  <Input type="tel" name="phone" value={formData.phone} onChange={handleChange} required placeholder="+1 (123) 456-7890" />
                  <Input type="number" name="weight" value={formData.weight} onChange={handleChange} placeholder="Weight (kg)" />
                  <Button type="submit" className="w-full bg-gradient-to-r from-red-600 to-yellow-500 text-white h-12">Get Quote Now</Button>
                </form>
              </CardContent>
            </Card>
          </div>
        </section>
      </div>
    </>
  );
};

export default WaterlooToIndiaPage;
